import Vue from "vue";
import Vuetify from "vuetify/lib";
import i18n from "@/i18n";

Vue.use(Vuetify);

const theme = {
  primary2: "#0C65AF",
  primary: "#109afd",
  secondary: "#EC407A",
  accent: "#9C27b0",
  info: "#E3F2FD",
  highlight: "#f3f4f6",
  "highlight-1": "#e5e7eb",
  "highlight-2": "#d1d5db",
  "grey-1": "#f3f4f6",
  "grey-2": "#e5e7eb",
  "grey-3": "#d1d5db",
  "grey-4": "#9ca3af",
  "grey-5": "#6b7280",
  
};
const darkTheme = {
  primary2: "#0C65AF",
  primary: "#109afd",
  secondary: "#EC407A",
  accent: "#9C27b0",
  info: "#263238",
  highlight: "#23272f",
  "highlight-1": "#2d323b",
  "highlight-2": "#3a3f4b",
  "grey-1": "#23272f",
  "grey-2": "#2d323b",
  "grey-3": "#3a3f4b",
  "grey-4": "#4b5563",
  "grey-5": "#6b7280",
 
};

export default new Vuetify({
  rtl: localStorage.getItem("lang") ? localStorage.getItem("lang") === "ar" : true,
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    dark: localStorage.getItem("darkMode") ? localStorage.getItem("darkMode") === "true" : false,
    themes: {
      dark: darkTheme,
      light: theme
    }
  }
});
